<template>
  <v-layout>
    <v-btn
      v-if="!menu"
      :disabled="disabled"
      class="my-0 mx-2 plus-button"
      @click="menu = true"
    >
      <v-icon>add</v-icon>
    </v-btn>
    <v-menu
      v-else
      v-model="menu"
      right
      offset-x
      :close-on-content-click="false"
      min-width="400"
    >
      <v-btn
        slot="activator"
        class="my-0 mx-2 plus-button"
      >
        <v-icon>add</v-icon>
      </v-btn>
      <v-card>
        <v-card-text style="height:230px;overflow-y:auto;">
          <v-data-table
            v-model="selected"
            hide-actions
            :items="filteredShippings"
            :headers="headers"
            item-key="id"
            :loading="loading"
          >
            <template
              slot="items"
              slot-scope="props"
            >
              <tr>
                <td>
                  <v-checkbox
                    v-model="selected"
                    :value="props.item"
                    primary
                    hide-details
                  />
                </td>
                <td>{{ props.item.id }}</td>
                <td>{{ props.item.number }}</td>
                <td>{{ props.item.date | date }}</td>
                <td>
                  {{ props.item.manager ? props.item.manager.title : "" }}
                </td>
                <td>{{ props.item.client ? props.item.client.title : "" }}</td>
                <td>
                  {{ props.item.country ? props.item.country.title : "" }}
                </td>
                <td>
                  {{ props.item.factory ? props.item.factory.title : "" }}
                </td>
                <td>{{ props.item.manufacturers }}</td>
                <td>
                  {{
                    props.item.unloadingCity
                      ? props.item.unloadingCity.title
                      : ""
                  }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="primary"
            flat
            small
            :disabled="loading"
            @click="pickup"
          >
            Сохранить
          </v-btn>
          <v-btn
            flat
            small
            @click="cancel"
          >
            Отменить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </v-layout>
</template>

<script>
import { getShippings } from "../../../backend/routesApi.js";

export default {
  props: {
    except: {
      default: () => [],
    },
    disabled: Boolean,
  },
  data() {
    return {
      loading: false,
      menu: false,
      selected: [],
      shippings: [],
      headers: [
        { text: "", sortable: false },
        { text: "Ид", sortable: false },
        { text: "Номер", sortable: false },
        { text: "Дата", sortable: false },
        { text: "Менеджер", sortable: false },
        { text: "Клиент", sortable: false },
        { text: "Страна", sortable: false },
        { text: "Продавец", sortable: false },
        { text: "Производитель", sortable: false },
        { text: "Город выгрузки", sortable: false },
      ],
    };
  },
  computed: {
    filteredShippings() {
      return this.shippings.filter(s => {
        return this.except.indexOf(s.id) === -1;
      });
    },
  },
  watch: {
    menu(value) {
      if (value) {
        this.getShippings();
      }
    },
  },
  methods: {
    async getShippings() {
      this.loading = true;
      const route = this.$store.getters["route/getRoute"];
      this.shippings = [];
      this.shippings = await getShippings(route.direction.id);
      this.loading = false;
    },
    cancel() {
      this.selected = [];
      this.shippings = [];
      this.menu = false;
    },
    pickup() {
      this.$emit("pickup", this.selected);
      this.cancel();
    },
  },
};
</script>
